import React from 'react'
import SideNav from '../../layouts/side-nav.js'
import {advantages} from './data/good-business.json'

import './style/good-business.css'

const components = ['why', 'press', 'history', 'questions', 'case-study', 'lease-loan', 'good-business']

export default (props) => (
  <div>
    <div className='good-hero'>
      <div className='good-hero-img' />
    </div>
    <div className='good-title'>
      Good Business
    </div>
    <div className='good-content'>
      <SideNav components={components} base='why' current='good-business' />
      <p className='good-opener'>
        You rely on equipment every day to operate and grow your business. But the value of that equipment comes from using it, not owning it. By leasing, you transfer the uncertainties and risks of equipment ownership to the lessor, which allows you to concentrate on using that equipment as a productive part of your business.
      </p>
      <p className='advantages-opener'>
        Leasing offers numerous advantages over other financing methods:
      </p>
      <ul className='advantages-list'>
        {advantages.map((advantage, i) => (<li key={i} className='advantage'>{advantage}</li>))}
      </ul>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/why/good-business.js